import { render, staticRenderFns } from "./EditProfileImageModal.vue?vue&type=template&id=4a2940b9&"
import script from "./EditProfileImageModal.vue?vue&type=script&lang=js&"
export * from "./EditProfileImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports